export default __webpack_public_path__ + "static/media/QSGRW_PC_Height.e3863e02.png";